/* tslint:disable */
/* eslint-disable */
export enum QuotationStage {
  Quotation = 'QUOTATION',
  Contract = 'CONTRACT',
  Invoiced = 'INVOICED',
}
